// Which app this browser tab should show. The same build is deployed to three
// Firebase Hosting sites; the hostname decides:
//   qpi-murugappan193.web.app   -> QPi (employee app)
//   admin-murugappan193.web.app -> QPi admin
//   anything else               -> the main QP website
// On local/Codespace dev hosts, ?site=qpi|admin|main switches apps for testing
// (remembered for the tab). The admin API checks roles on every request, so
// this is routing only - never the security layer.
const DEV_HOST = /(^localhost$|^127\.0\.0\.1$|\.github\.dev$|\.app\.github\.dev$|\.gitpod\.io$)/;

export function isDevHost(hostname = window.location.hostname) {
  return DEV_HOST.test(hostname);
}

export function siteMode() {
  const host = window.location.hostname.toLowerCase();
  if (host.startsWith("qpi-")) return "qpi";
  if (host.startsWith("admin-")) return "admin";
  if (isDevHost(host)) {
    try {
      const param = new URLSearchParams(window.location.search).get("site");
      if (param) sessionStorage.setItem("qp_site_mode", param);
      const stored = sessionStorage.getItem("qp_site_mode");
      if (stored === "qpi" || stored === "admin") return stored;
    } catch (e) {
      // sessionStorage unavailable - fall through to the main site
    }
  }
  return "main";
}

export const QPI_URL = "https://qpi-murugappan193.web.app";
export const ADMIN_URL = "https://admin-murugappan193.web.app";
